import {SideNavInterface} from '../../interfaces/side-nav.type';


export const ROUTESSM: SideNavInterface[] = [
  {
    path: 'eod',
    title: 'Sales EOD',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'file-done',
    submenu: []
  },
  {
    path: 'lead',
    title: 'Visits & Reports',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'file-done',
    submenu: []
  },
];
